import * as React from "react";
export interface IEmailSearchInputProps {
  email1: string;
  onSearch: (email1: string) => void;
}
class EmailSearchInput extends React.PureComponent<IEmailSearchInputProps, any> {
  constructor(props: IEmailSearchInputProps) {
    super(props);
    this.state = {
      email1: this.props.email1
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.email1 != this.props.email1) {
      this.setState({
        email1: this.props.email1
      });
    }
  }
  render() {
    const {
      onSearch
    } = this.props;
    let self = this;
    return <div className="generic-form-field" data-sentry-component="EmailSearchInput" data-sentry-source-file="EmailSearchInput.tsx">
            <div className="input-group">
                <input type="text" placeholder={"Email..."} className="form-control" style={{
          width: "420px"
        }} name="email1" id="email1" value={this.state.email1} onChange={e => {
          self.setState({
            email1: e.target.value
          });
        }} />
                <div className="input-group-append">
                    <button onClick={() => onSearch(this.state.email1)} type="button" className="btn btn-secondary">
                        {"Search"}
                    </button>
                </div>
            </div>
        </div>;
  }
}
export default EmailSearchInput;